import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogTitle, Stack, Divider, TextField } from '@mui/material';

import { DialogCloseButton } from '../../../components/core/DialogCloseButton';
import { testId as parentTestId } from '../util';
import { Button } from '../../../components/core/Button/Button';
import { Domain } from '../../../store/modules/merchant/types';

export const testId = `${parentTestId}-ADD_MODAL`;

interface Props {
  onSave: (domain: string) => Promise<any>;
  isOpen: boolean;
  onClose: () => void;
  domainToEdit?: Domain;
}

export const AddDomainModal = ({ isOpen, onSave, onClose, domainToEdit }: Props) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [endpointUrl, setEndpointUrl] = useState('');
  const isEditMode = Boolean(domainToEdit);

  useEffect(() => {
    if (isOpen) {
      setEndpointUrl(domainToEdit?.url ?? '');
    }
  }, [isOpen, domainToEdit]);

  const onChangeEndpointUrl = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEndpointUrl(e.target.value);
  };

  const onSaveWithEffects = async (domain: string) => {
    setIsProcessing(true);
    return onSave(domain).finally(() => setIsProcessing(false));
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{ sx: { borderRadius: 4 } }}
    >
      <DialogTitle sx={{ fontWeight: 600 }}>
        {isEditMode ? 'Edit merchant domain' : 'Add merchant domain'}
      </DialogTitle>
      <DialogCloseButton onClose={onClose} />
      <DialogContent dividers>
        <TextField
          label="Domain URL"
          required
          value={endpointUrl}
          onChange={onChangeEndpointUrl}
          placeholder="Enter the domain here using 'https://' or 'http://'"
          inputProps={{ 'data-testid': `${testId}-ADD_INPUT` }}
        />
        <Divider sx={{ mt: 4, mb: 2 }} />
        <Stack direction="row" spacing={1}>
          <Button
            text="Cancel"
            theme="secondary"
            onClick={onClose}
            isFullWidth
            dataTestId={`${testId}-ADD_INPUT-CANCEL_BUTTON`}
          />
          <Button
            text="Save"
            theme="primary"
            onClick={() => onSaveWithEffects(endpointUrl)}
            disabled={isProcessing}
            loading={isProcessing}
            isFullWidth
            dataTestId={`${testId}-ADD_INPUT-SAVE_BUTTON`}
          />
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
